import React from 'react';
import { URLS } from '../../_config';
import { Link } from 'react-router-dom';
import { useToken } from '../../_common/hooks/authHook';
import { APP_NAME, LOGO_URL } from '../../_config/site_urls';
import ThankYouFooter from '../../components/layouts/ThankYouFooter';
import { useLocation } from 'react-router-dom';

const ApproveOrRejectViaMail: React.FC = () => {
    let tokenData: any = useToken('info');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const title = queryParams.get('title');
    const message = queryParams.get('msg');

    return (
        <div className="thank-you-page">
            <div className="home-icon"><Link to={URLS.HOME}><i className='bx bx-home'></i></Link>
            </div>
            <div>
                <Link to={URLS.HOME}><img className="nav-logo" src={LOGO_URL} alt={APP_NAME} /></Link>
            </div>
            <div className="thank-you-text">
                <img src="/images/img/thank-you-img.png" alt='Thank You' className='float-left' />
                <h1>
                    {title?.split(' ').map((word, index) => (
                        <>
                            {
                                (index === 0) ? ` ${word} ` : <span key={index} style={{ display: 'inline-block', marginRight: '5px' }}>
                                    {word}
                                </span>
                            }
                        </>
                    ))}
                </h1>
                <p>{message} </p>
                <span data-aos="zoom-in" className="aos-init aos-animate">
                    <Link to={(tokenData) ? URLS.ACCOUNT.MY_BUSINESS_PLAN : URLS.LOGIN}>
                        <button type="button" className="master-orng-btn xl-orng-btn">{(tokenData) ? "My business services" : "Log In to Your Account"}</button>
                    </Link>
                </span>
            </div>

            <ThankYouFooter />
        </div>
    );
};

export default ApproveOrRejectViaMail;